/**
 * Created by - Ashlekh on 24-04-2025
 * Reason - To add school page
 */

import parse from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import config from "../../Api/config";
import { getSchoolDetailsAPI } from "../../Api/services";
import NavigationPath from "../../components/NavigationPath/NavigationPath";
import { GlobalContext } from "../../context/Context";
import style from "./School.module.css";

const School = () => {
  const { navigationPath, setNavigationPath } = useContext(GlobalContext);
  const [showContent, setShowContent] = useState(false);
  // Added by - Ashlekh on 24-04-2025
  // Reason - To set page content
  const [pageContent, setPageContent] = useState({});
  // End of code - Ashlekh on 24-04-2025
  // Reason - To set page content
  // Added by - Ashlekh on 24-04-2025
  // Reason - This useEffect will execute when page loads
  // Added by - Yogen on 22-06-2025
  // Reason - UseState to store school images, marquee url and marquee text
  const [schoolImage, setSchoolImage] = useState([]);
  const [marqueeUrl, setMarqueeUrl] = useState("");
  // const [marqueeText, setMarqueeText] = useState("");
  // End of code - Ashlekh on 22-06-2025
  // Reason - UseState to store school images, marquee url and marquee text

  useEffect(() => {
    setNavigationPath([
      { name: "Home", path: "/" },
      { name: "School", path: "/school" },
    ]);
    window.scrollTo(0, 0);
    schoolDetails();
  }, []);
  // End of code - Ashlekh on 24-04-2025
  // Reason - This useEffect will executes when page loads

  // Added by - Ashlekh on 24-04-2025
  // Reason - To get details from backend
  const schoolDetails = async () => {
    try {
      const response = await getSchoolDetailsAPI();
      setPageContent(response?.school_details);
      // Added by - Yogen on 22-06-2025
      // Reason - To store school images, marquee url marquee text
      setSchoolImage(response?.school_image); 
      setMarqueeUrl(response?.school_details?.marquee_url);
      // setMarqueeText(response?.school_details?.marquee_text);
      // End of code - Yogen on 22-06-2025
      // Reason - To store school images, marquee url marquee text
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setShowContent(true);
    }
  };
  // End of code - Ashlekh on 24-04-2025
  // Reason - To get details from backend
  return (
    <div>
      {showContent ? (
        <div className={`${style.mainContainer}`}>
          {pageContent?.banner_image ? (
            <div className={`${style.bannerImage}`}>
              <img
                className={`${style.image}`}
                src={config.baseURL + pageContent?.banner_image}
                alt=""
              />
            </div>
          ) : null}
          {/* Added by - Yogen on 22-06-2025
          Reason - To display Marquee URL */}
          {marqueeUrl?.length > 0 && (
            <div className={`${style.marqueeTextContainer}`}>
              <Marquee>
                {/* <Link to={marqueeUrl} className={`${style.marqueeTextGradient}`}>
                  {marqueeUrl}
                </Link> */}
                <a
                  href={marqueeUrl}
                  target="_blank"
                  className={`${style.marqueeTextGradient}`}
                >
                  {marqueeUrl}
                </a>
              </Marquee>
            </div>
          )}
          {/* End of code - Ashlekh on 22-06-2025
          Reason - To display Marquee URL */}

          <NavigationPath navigationPathArray={navigationPath} />
          {pageContent?.description || pageContent?.description?.length > 0 ? (
            <div className={`${style.pageTitle}`}>School</div>
          ) : (
            <p className={style.noDetailsAvailableText}>No details available</p>
          )}
          {pageContent?.description ? (
            <div className={`${style.description}`}>
              {" "}
              {parse(pageContent?.description)}{" "}
            </div>
          ) : null}
        </div>
      ) : (
        <div className={style.loaderContent}>
          <img style={{ height: "30vh" }} src="/adyant_loader.gif" />
        </div>
      )}
      {/* Added By - Yogen on 22-06-2025
        Reason : to display the school image  */}
      {schoolImage?.length > 0 ? (
        <div className={`${style.imageContainer}`}>
          {schoolImage?.map((item, index) => (
            <div key={index} className={`${style.imageSubContainer}`}>
              <img
                className={`${style.galleryImage}`}
                src={config.baseURL + item?.image}
                alt=""
              />
            </div>
          ))}
        </div>
      ) : null}
      {/* Ended By - Yogen on 22-06-2025
        Reason : to display the school image  */}
    </div>
  );
};
export default School;
